import { ChatMessageType, type ChatConversationDto, type ChatMessageDto } from "../contracts";

export type ChatMessageViewModel = ChatMessageDto; // Will likely need to be extended with client-only properties in the future, so keeping it separate from the DTO for now
export type ChatConversationViewModel = ChatConversationDto & { messages: ChatMessageViewModel[] };

export const getLastUserText = (
    messages: ChatMessageViewModel[] | undefined
): string | undefined => {
    if (!messages || messages.length === 0) {
        return undefined;
    }

    const lastMessage = messages.at(-1);

    if (lastMessage?.type !== ChatMessageType.ToolRequest) {
        return undefined;
    }

    const previousMessage = messages.at(-2);

    return previousMessage?.type === ChatMessageType.User
        ? previousMessage.text ?? ""
        : undefined;
};
